// src/hooks/hotelRoomCategories/useDeleteHotelRoomCategory.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteHotelRoomCategory } from "../../api/apiHotelRoomCategories";
import parseError from "../../utils/parseError";

const useDeleteHotelRoomCategory = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteHotelRoomCategories, isPending: isDelete } = useMutation({
        mutationFn: deleteHotelRoomCategory,
        onSuccess: (res) => {
            const message = res?.message || "Hotel room category deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelRoomCategories"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete hotel room category");
        },
    });

    return { deleteHotelRoomCategories, isDelete };
};

export default useDeleteHotelRoomCategory;
